import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class AbsoluteButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.onComplete = this.onComplete.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }



    onComplete() {

    }

    render() {

        return (

            <button className={`btn btn-lg guroo-btn abs-btn ${this.props.class}`} ref={this.props.id} disabled={this.props.isDisabled} onClick={this.props.onClick}>{this.props.label}</button>

        );
    }
}

AbsoluteButton.propTypes = {
    label: PropTypes.string,
    class: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    alignment: PropTypes.string,
    isDisabled: PropTypes.bool,
};

AbsoluteButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AbsoluteButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/AbsoluteButton.js
 **/